import { ADD_UPDATE_HPE_CUSTOMER_FAILURE, 
    ADD_UPDATE_HPE_CUSTOMER_REQUEST, 
    ADD_UPDATE_HPE_CUSTOMER_SUCCESS, 
    FETCH_HPE_CUSTOMER_LIST_FAILURE, 
    FETCH_HPE_CUSTOMER_LIST_REQUEST, 
    FETCH_HPE_CUSTOMER_LIST_SUCCESS } from "./actionTypes";
import { HPECustomers } from "./types";

export const fetchHPECustomerListRequest = (
  url: string,
  payload: {
    pageNumber: number;
    pageSize: number;
    sortColumn: string;
    sortOrder: string;
    searchValue: string;
  },
) => ({
  type: FETCH_HPE_CUSTOMER_LIST_REQUEST,
  url,
  payload,
});

export const fetchHPECustomerListSuccess = (
  HPECustomerList: HPECustomers[],
  totalCount: number,
) => ({
  type: FETCH_HPE_CUSTOMER_LIST_SUCCESS,
  payload: { HPECustomerList, totalCount },
});

export const fetchHPECustomerListFailure = (error: string) => ({
  type: FETCH_HPE_CUSTOMER_LIST_FAILURE,
  payload: error,
});

export const addUpdateHPECustomerRequest = (
  url: string,
  payload: any,
  callback: unknown,
) => ({
  type: ADD_UPDATE_HPE_CUSTOMER_REQUEST,
  url,
  payload,
  callback,
});

export const addUpdateHPECustomerSuccess = (
  successMessage: string,
) => ({
  type: ADD_UPDATE_HPE_CUSTOMER_SUCCESS,
  payload: { successMessage },
});

export const addUpdateHPECustomerFailure = (error: string) => ({
  type: ADD_UPDATE_HPE_CUSTOMER_FAILURE,
  payload: error,
});
